import { Card } from "@fanduel/og-fe-library";
import { NextSeo } from "next-seo";
import ErrorComponent from "@/components/empty/ErrorComponent";
import HorseRacingHeader from "@/components/horseRacing/header";
import TrackInfo from "@/components/horseRacing/trackInfo";
import TrackRaces from "@/components/horseRacing/trackRaces";
import BasicTerms from "@/components/horseRacing/widgets/basicTerms";
import UpcomingRaces from "@/components/horseRacing/widgets/upcomingRaces";
import { SEO } from "@/constants/seo";
import { Hr_PastTrack } from "@/graphql/gql/graphql";
import { TermsT } from "@/types/horseRacing";
import useAllRacesByTrack from "@/utils/hooks/useAllRacesByTrack";
import styles from "./container.module.scss";

interface TrackDetailContainerProps {
  trackCode: string;
  trackDetails: Hr_PastTrack;
  initialTerms: TermsT;
}

const TrackDetailContainer = ({
  initialTerms,
  trackCode,
  trackDetails,
}: TrackDetailContainerProps) => {
  const title = trackDetails.name
    ? `Today's ${trackDetails.name} Horse Racing Picks`
    : "Race Track";
  const description = `Check out today's best picks for ${trackDetails.name}. FanDuel Research provides daily horse racing predictions for all upcoming races!`;
  const { races, isError } = useAllRacesByTrack(trackCode); // todo implement display
  const canonicalUrl = SEO.getTrackDetailUrl(
    trackCode,
    trackDetails.name ?? ""
  );

  return (
    <div className={styles.container}>
      <NextSeo
        title={title}
        description={description}
        canonical={canonicalUrl}
      />
      <HorseRacingHeader title={title} />
      <TrackInfo trackDetails={trackDetails} numRaces={races.length} />
      <div className={styles.contentContainer}>
        {races && races.length > 0 ? (
          <TrackRaces races={races} />
        ) : (
          <Card
            variant="elevation"
            elevation="mid"
            className={styles.errorContainer}
          >
            <ErrorComponent
              headline={
                isError ? "Content failed to load" : "No races available"
              }
              subtext={
                isError ? (
                  <div>
                    <p>No Races available.</p>
                    <p>Please check back later.</p>
                  </div>
                ) : (
                  "Please check back later."
                )
              }
              showCta={isError}
            />
          </Card>
        )}
        <div className={styles.widgetContainer}>
          <UpcomingRaces />
          <BasicTerms initialTerms={initialTerms} />
        </div>
      </div>
    </div>
  );
};

export default TrackDetailContainer;
